import { PageViewportService } from '@blocksuite/hive-shared/services';

import type { HiveDragHandleWidget } from '../drag-handle.js';

export class PageWatcher {
  get pageViewportService() {
    return this.widget.std.get(PageViewportService);
  }

  constructor(readonly widget: HiveDragHandleWidget) {}

  watch() {
    const { disposables } = this.widget;

    disposables.add(
      this.widget.doc.slots.blockUpdated.subscribe(() => this.widget.hide())
    );

    disposables.add(
      this.pageViewportService.subscribe(() => {
        this.widget.hide();
      })
    );
  }
}
